/* eslint-disable no-use-before-define,react-hooks/exhaustive-deps */
import React from 'react'
import { Status, ajax, fmt, hideModal } from '../../twd'
import { parseDetail } from '../use-orders'
export default ({orderNo, action:action_='view', isNote:isNote_} = {}) => {

    const [status, setStatus] = React.useState(Status.LOADING)
    const [detail, setDetail] = React.useState(null)
    const [action, setAction] = React.useState(action_)
    const [isNote, setIsNote] = React.useState(isNote_)
    const [title, setTitle] = React.useState(
        {
            'view': 'View Order',
            'cancel': 'Request Cancel Order',
            'accept': 'Accept Order',
            'accept-buy': 'Accept Buy Order',
            'accept-sell': 'Accept Sell Order',
            'sell': 'Sell Order',
            'buy': 'Buy Order'
        }[action]
    )

    React.useEffect(() => {
        if (!orderNo) {
            hideModal()
            return
        }

        setStatus(Status.LOADING)

        ;(async ()=> {
            try {

                let {data} = await ajax({
                    url:'/esb/portfolio/trades/details',
                    method: 'GET',
                    isDc: false,
                    type: 'text',
                    params: { orderNo }
                })

                const detail = parseDetail(await data)
                if (!detail.cusip && detail.WARNING) {
                    throw new Error(detail.WARNING)
                }

                let a = parseYield(detail.ytm)
                Object.assign(detail, { ytm:a.yld, ytmDt:a.dt })
                a = parseYield(detail.yldCall)
                Object.assign(detail, { ytc:a.yld, ytcDt:a.dt })
                a = parseYield(detail.yldParCall)
                Object.assign(detail, { ytp:a.yld, ytpDt:a.dt })
                a = parseYield(detail.yieldToWorst)
                Object.assign(detail, { ytw:a.yld, ytwDt:a.dt })

                if (detail.accruedInterest===null) {
                    detail.accruedInterest = "$0"
                }
                if (detail.accruedInterest==='-') {
                    detail.accruedInterest = null
                }
                if (detail.principal==='-') {
                    detail.principal = null
                }

                if (!detail.ytwDt) {
                    detail.ytwDt = detail.ytm===detail.ytw ? detail.ytmDt :
                        detail.ytc===detail.ytw ? detail.ytcDt :
                        detail.ytp===detail.ytw ? detail.ytpDt :
                        detail.ytwDt
                }

                let {data:issuedata} = await ajax({
                    url:'/esb/portfolio/cusip/issuedata',
                    method: 'GET',
                    params: { cusip: detail.cusip }
                })

                detail.issuedata = (await issuedata).IssueData || {}
                setDetail(detail)

                if (action_==='?') {
                    const sd = detail.ordStatusDesc
                    const od = detail.ordStatus
                    const a  = (sd === "Pending" && od === '0') ? 'accept'
                        : (['Pending','Accepted', 'Showing'].indexOf(sd)>=0) ? 'cancel'
                        : (['X', 'Y', 'A', '0'].indexOf(od)>=0) ? 'cancel'
                        : ''
                    setAction(a)
                    setIsNote(a==='accept' && detail.ordSubStatus==='C')
                }

                setStatus(Status.LOADED)

            } catch(e) {
                console.log(e)
                setStatus(Status.FAILED_TO_LOAD)
                hideModal()
            }
        })()

    }, [orderNo])

    React.useEffect(() => {
        if (!detail) return

        if (action==='accept') {
            const t = detail.action==='F' || detail.action === 'B' ? 'Accept Buy Order' :
                detail.action==='W' || detail.action === 'S' ? 'Accept Sell Order' :
                'Accept Order'
            setTitle(t)
        }
        else if(action==='cancel') {
            setTitle('Request Cancel Order')
        }

    }, [action, detail])


    return { status, detail, action, isNote, title }
}

const parseYield = (t) => {
    return { yld: parseNumber(t), dt:parseDate(t) }
}
const parseNumber = (t) => {
    const n = Number.parseFloat(t)
    return isNaN(n) ? null : n
}

const parseDate = (t) => {
    return !t ? null: fmt.mdy(new Date(((String(t || '').split("<br>")[1] || '')).split('@')[0]))
}